import { render, staticRenderFns } from "./Manage-Accept-Remark.vue?vue&type=template&id=422dc924"
import script from "./Manage-Accept-Remark.vue?vue&type=script&lang=js"
export * from "./Manage-Accept-Remark.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports